// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M19 9l-7 7-7-7\"/> </svg> ";
// Exports
module.exports = code;